declare let globalLanguage: string;
let currentLanguage = globalLanguage || "nl";

const translations = {

    nl: {"accDetails_Description":"Omschrijving","accDetails_Reviews":"Reviews","accDetails_Reviews_OutOf":"van de","accDetails_Reviews_ReviewsShown":"reviews getoond.","accDetails_ViewDetailsBtn":"Bekijk details","closeMap":"Kaart sluiten","filter_Confirm":"Bevestig","logoUrl":"/App_Resources/Images/LTLogoLanguageVariants/Logo_NL_White.svg","no":"Nee","rootUrl":"/nl/","yes":"Ja"},
    en: {"accDetails_Description":"Description","accDetails_Reviews":"Reviews","accDetails_Reviews_OutOf":"out of","accDetails_Reviews_ReviewsShown":"reviews shown.","accDetails_ViewDetailsBtn":"View details","closeMap":"Close map","filter_Confirm":"Confirm","logoUrl":"/App_Resources/Images/LTLogoLanguageVariants/Logo_EN_White.svg","no":"No","rootUrl":"/en/","yes":"Yes"},
    de: {"accDetails_Description":"Beschreibung","accDetails_Reviews":"Rezensionen","accDetails_Reviews_OutOf":"von","accDetails_Reviews_ReviewsShown":"Bewertungen angezeigt.","accDetails_ViewDetailsBtn":"Details ansehen","closeMap":"Karte schlie\u00DFen","filter_Confirm":"Best\u00E4tigen","logoUrl":"/App_Resources/Images/LTLogoLanguageVariants/Logo_DE_White.svg","no":"Nein","rootUrl":"/de/","yes":"Ja"}
};

interface appTranslations {

    accDetails_Description: string; 
    accDetails_Reviews: string; 
    accDetails_Reviews_OutOf: string; 
    accDetails_Reviews_ReviewsShown: string; 
    accDetails_ViewDetailsBtn: string; 
    closeMap: string; 
    filter_Confirm: string; 
    logoUrl: string; 
    no: string; 
    rootUrl: string; 
    yes: string; 

}

//@ts-ignore
let currentTranslation = (currentLanguage in translations) ? translations[currentLanguage] : translations["nl"];

export default currentTranslation as appTranslations;